module.exports = __webpack_public_path__ + "img/yellow-triangle.409dfbb9.svg";